module.exports = __webpack_public_path__ + "static/img/szechenyi2020.afc3eb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners/szechenyi2020.png
// module id = 878
// module chunks = 93